import DashboardCard, { EmptyState } from './DashboardCard';
import CardGrid from './CardGrid';
import { CARD_FILL_MIN_WIDTH, cardDateColumn, type CardColumn } from './cardColumns';
import type { DashboardDietOrderChange } from '../../types/dashboard';
import { useDashboardNav, RESIDENT_TAB } from './useDashboardNav';

const columns: CardColumn<DashboardDietOrderChange>[] = [
  cardDateColumn<DashboardDietOrderChange>('change_Date', 'Date', { sortOrder: 'desc' }),
  { dataField: 'fullName', caption: 'Name', sizing: 'fill' },
  { dataField: 'dietOrder', caption: 'Diet Order', sizing: 'fill', minWidth: CARD_FILL_MIN_WIDTH },
];

interface Props {
  data: DashboardDietOrderChange[];
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
}

export default function DietOrderChangesCard({ data, ...dragProps }: Props) {
  const { rowLinkProps } = useDashboardNav();
  return (
    <DashboardCard severity="warning" icon="bi-clipboard2-pulse" title="Diet Order Changes" count={data.length} {...dragProps}>
      {data.length === 0 ? (
        <EmptyState message="No diet order changes" />
      ) : (
        <CardGrid<DashboardDietOrderChange>
          {...rowLinkProps<DashboardDietOrderChange>((r) => r.fKey_Patient, RESIDENT_TAB.dietOrder)}
          ariaLabel="Diet Order Changes"
          dataSource={data}
          columns={columns}
          keyExpr="pKey_Diet_Flucs"
        />
      )}
    </DashboardCard>
  );
}
